import { useEffect, useState } from "react";
import api, { formatApiError } from "@/lib/api";
import { Button } from "@/components/ui/button";
import { Label } from "@/components/ui/label";
import { Textarea } from "@/components/ui/textarea";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { Loader2, XCircle } from "lucide-react";
import { toast } from "sonner";

// Satın Alma Talebi (ST) belge iptali — gerekçe zorunlu; bağlı PO varsa backend 409 mesajı gösterilir
export default function CancelPurchaseRequestDialog({ request, onClose, onDone }) {
  const [reason, setReason] = useState("");
  const [busy, setBusy] = useState(false);
  const [error, setError] = useState("");
  useEffect(() => { setReason(""); setError(""); }, [request?.id]);

  const submit = async () => {
    if (busy || !reason.trim()) return;
    setBusy(true); setError("");
    try {
      const { data } = await api.post(`/purchase-requests/${request.id}/cancel`, { reason: reason.trim() });
      toast.success(`${data.request_no} ${data.already ? "zaten iptal edilmişti" : "iptal edildi"} — miktar açık ihtiyaca döndü`);
      onDone?.();
      onClose();
    } catch (e) { setError(formatApiError(e)); }
    finally { setBusy(false); }
  };

  return (
    <Dialog open={!!request} onOpenChange={(v) => !v && !busy && onClose()}>
      <DialogContent className="max-w-md rounded-sm" data-testid="cancel-request-dialog">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><XCircle className="w-4 h-4 text-rose-400" /> Satın Alma Talebini İptal Et</DialogTitle>
          <DialogDescription>
            {request?.request_no} iptal edilecek. Kayıt silinmez; talepteki miktar ilgili sipariş/ürün/beden için açık ihtiyaca geri döner.
          </DialogDescription>
        </DialogHeader>
        <div className="space-y-1.5">
          <Label className="text-xs uppercase font-mono text-muted-foreground">İptal gerekçesi *</Label>
          <Textarea rows={3} value={reason} onChange={(e) => setReason(e.target.value)} className="rounded-sm"
            placeholder="Örn. Müşteri siparişi değişti" data-testid="cancel-request-reason" />
        </div>
        {error && <div className="text-xs text-rose-400 border border-rose-900/60 bg-rose-950/30 rounded-sm p-2" data-testid="cancel-request-error">{error}</div>}
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={onClose} disabled={busy} className="rounded-sm" data-testid="cancel-request-close">Vazgeç</Button>
          <Button onClick={submit} disabled={busy || !reason.trim()} className="rounded-sm bg-rose-600 hover:bg-rose-500 text-white" data-testid="cancel-request-confirm">
            {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : "Talebi İptal Et"}
          </Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
}
